import { PartnerGroupMappedShow } from "./partner-group-mapped-show";

export class ShowMapperProfile {
    id: number = 0;
    partnerGroupMappedShows: PartnerGroupMappedShow[] = [];
    partnerProImportDetails: any = {};
    isApproved: boolean = false;

    static mapProperties(item: any): ShowMapperProfile {
        return {
            id: item.id,
            partnerGroupMappedShows: item.partner_group_mapped_shows.map((show:any) => PartnerGroupMappedShow.mapProperties(show)),
            partnerProImportDetails: item.partner_pro_import_details,
            isApproved: item.is_approved
        }
    }
}
